import { getModule, Module } from 'vuex-module-decorators'
import store from '@/store'
import IndustryRelationModule from '../../../common/tag/industry/IndustryRelationModule'

@Module({
  namespaced: true,
  name: 'IndustryRelationCustomerModule',
  store,
  dynamic: true
})
class IndustryRelationCustomerModule extends IndustryRelationModule {}

export default getModule(IndustryRelationCustomerModule)
